var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKapPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kaplica_rzymskokatolicka"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "86.21 84.15 126.64 50.18 169.79 82.09",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.66 42.66 139.67 41.75 130.22 18.56 117.66 42.66",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.1,
    y1: 83.65,
    x2: 166.26,
    y2: 82.94,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.7,
    y1: 80.35,
    x2: 165.38,
    y2: 79.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "117.66 42.66 128.44 36.93 139.67 41.75",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "136.31 107.96 165.87 107.98 166.01 83.82",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.77 83.72 90.91 107.93 108.69 107.94",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "113.09 104.74 128.66 104.68 131.82 103.81",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "111.44 106.66 128.62 106.57 132.99 105.39",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.53 108.59 128.57 108.46 134.93 107.08",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "112.59 89.85 123.97 82.87 135.57 89.63",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.57 87.12 100.63 87.1 100.61 98.88 107.48 98.82 107.57 87.12",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.17,
    y1: 98.79,
    x2: 104.22,
    y2: 87.24,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.63,
    y1: 90.17,
    x2: 107.4,
    y2: 90.09,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.7,
    y1: 92.95,
    x2: 107.38,
    y2: 92.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.77,
    y1: 95.53,
    x2: 107.13,
    y2: 95.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.24,
    y1: 98.81,
    x2: 108.83,
    y2: 98.7,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.22 86.22 148.9 86.2 148.81 97.46 155.08 97.41 155.22 86.22",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.72,
    y1: 97.37,
    x2: 152.17,
    y2: 86.33,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.79,
    y1: 89.12,
    x2: 154.96,
    y2: 89.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.76,
    y1: 91.79,
    x2: 154.85,
    y2: 91.64,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.73,
    y1: 94.25,
    x2: 155.15,
    y2: 94.22,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.22,
    y1: 97.38,
    x2: 155.97,
    y2: 97.29,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.05,
    y1: 104.99,
    x2: 109.38,
    y2: 104.99,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.56,
    y1: 104.58,
    x2: 165.6,
    y2: 104.21,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "113.03 89.93 116.31 89.99 125.16 84.25",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.88,
    y1: 42.94,
    x2: 119.68,
    y2: 55.38,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.36,
    y1: 42.22,
    x2: 136.91,
    y2: 58.04,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.22 42 142.49 49.95 140.66 50.04",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "140.14 59.75 140.48 48.8 137.6 44.23",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.51 39.66 140.01 40.3 142.36 49.46",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.62,
    y1: 1.29,
    x2: 130.22,
    y2: 18.56,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.83,
    y1: 7.4,
    x2: 136.11,
    y2: 6.43,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "125.43 50.66 125.56 44.5 131.95 44.28 131.74 52.53 130.56 52.47",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "165.87 107.98 167.17 105.92 167.22 86.05 169.49 82.65",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  })), /*#__PURE__*/React.createElement("rect", {
    x: 120.28,
    y: 88.23,
    width: 8.81,
    height: 15.68,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 66.03,
    width: 6.7,
    height: 13.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.53
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKapPop);
export default __webpack_public_path__ + "static/media/kap_pop.5ec9f179f067494e35f6319b114d4b41.svg";
export { ForwardRef as ReactComponent };